import React from "react";

function PgTypeBadge({ value }) {
  const variant =
    value === "Customer" ? "pg-type-badge--customer" : "pg-type-badge--nike";
  return <span className={`pg-type-badge ${variant}`}>{value}</span>;
}

export default PgTypeBadge;
